/* ============================================================
   Award Proof — rebuilds a customer's approved design from the
   URL query string (written by the builder as _proof_url).
   Reuses award-builder.css for the preview styling. The crest
   image can't travel in a URL, so the owner loads it from the
   order's Crest file with the drop control.
   ============================================================ */
(function(){
"use strict";
var root = document.querySelector(".awb-proofpage");
if(!root) return;
var $ = function(id){ return document.getElementById(id); };

var P = {};
new URLSearchParams(window.location.search).forEach(function(v, k){ P[k] = v; });

var months = (P.months || "").split(",").filter(Boolean);
var previewMonth = months[0] || P.month || "";
var crestUrl = null;

// if the design has no crest, hide the "load crest" control
if(P.scr === "0"){ var _drop = $("proof-crestdrop"); if(_drop) _drop.hidden = true; }

function colourP(els, col, outline){
  els.forEach(function(el){
    if(!el) return;
    el.style.color = col;
    el.style.webkitTextStrokeWidth = outline ? "0.4cqw" : "0";
    el.style.webkitTextStrokeColor = strokeColP(col);
  });
}
function strokeColP(col){ return isLightP(col) ? "#0A0A0A" : "#FFFFFF"; }
function isLightP(hex){
  hex = (hex || "").replace("#","");
  if(hex.length === 3) hex = hex.replace(/(.)/g, "$1$1");
  var r = parseInt(hex.substr(0,2),16), g = parseInt(hex.substr(2,2),16), b = parseInt(hex.substr(4,2),16);
  if(isNaN(r)) return false;
  return (0.299*r + 0.587*g + 0.114*b) > 150;
}

function render(){
  $("proof-bg").style.backgroundImage = P.bg || "linear-gradient(160deg,#232827,#0E1211)";

  var aw = $("proof-award");
  aw.style.fontFamily = P.font || "'Anton',sans-serif";
  aw.style.setProperty("--sztitle", P.zt || 1);
  aw.style.setProperty("--szclub", P.zc || 1);
  aw.style.setProperty("--szmonth", P.zm || 1);
  aw.style.setProperty("--szseason", P.zs || 1);

  var lay = $("proof-layout");
  lay.className = "layout " + (P.layout || "classic")
    + (P.cfree === "1" ? " awb-crestfree" : "")
    + (P.cfront === "1" ? " awb-crest-front" : "")
    + (P.layout === "crest-first" ? "" : " awb-v" + (P.vp || "center"));
  lay.style.setProperty("--crest-w", (P.crestsize || 46) + "cqw");
  $("proof-crest").style.setProperty("--crest-x", (P.cx || 0) + "cqw");   // badge nudge (matches builder)
  $("proof-crest").style.setProperty("--crest-y", (P.cy || 0) + "cqw");

  $("proof-lk1").textContent = P.a || "";
  $("proof-lk1").hidden = !P.a;
  $("proof-lk2").textContent = P.b || "";
  if(P.c){
    $("proof-lkcon").innerHTML = P.c.split(" ").map(function(x){ return "<span>" + x + "</span>"; }).join("");
    $("proof-lkcon").hidden = false;
  } else { $("proof-lkcon").hidden = true; }

  $("proof-club").textContent = P.club || "";
  $("proof-club").hidden = !P.club || P.sc === "0";

  $("proof-month").textContent = (previewMonth && previewMonth !== "—") ? previewMonth : "";
  $("proof-month").hidden = !previewMonth || previewMonth === "—" || P.sm === "0";

  $("proof-season").textContent = P.season || "";
  $("proof-season").hidden = !P.season || P.ss === "0";

  colourP([$("proof-lk1"), $("proof-lk2"), $("proof-lkcon")], P.ct || "#FFFFFF", P.ot === "1");
  colourP([$("proof-club")], P.cc || "#FFFFFF", P.oc === "1");
  colourP([$("proof-month")], P.cm || "#FFFFFF", P.om === "1");
  colourP([$("proof-season")], P.cs || "#F0B62C", P.oe === "1");

  if(P.scr === "0"){
    $("proof-crest").hidden = true;
    $("proof-crest").innerHTML = "";
  } else if(crestUrl){
    $("proof-crest").hidden = false;
    $("proof-crest").innerHTML = '<img src="' + crestUrl + '" alt="Club crest">';
  } else {
    $("proof-crest").hidden = false;
    $("proof-crest").innerHTML = '<div class="crest-ph">Crest — load below</div>';
  }

  $("proof-sponsor").hidden = !(P.sponsor === "1");

  // match the builder's section order
  if(P.ord){
    var omap = { crest:"proof-crest", title:"proof-lockup", club:"proof-club", month:"proof-month", season:"proof-season", sponsor:"proof-sponsor" };
    P.ord.split(",").forEach(function(k){ var el = omap[k] && $(omap[k]); if(el) lay.appendChild(el); });
  } else if(P.layout === "crest-first"){
    lay.insertBefore($("proof-crest"), lay.firstChild);
    lay.insertBefore($("proof-club"), $("proof-lockup"));
  }

  fit();
  drawStrip();
  spec();
}

function fit(){
  var lay = $("proof-layout");
  var avail = lay.clientWidth - (lay.clientWidth * 0.10);
  if(avail <= 0) return;
  fitOne($("proof-lk1"), "--fit", avail);
  fitOne($("proof-lk2"), "--fit", avail);
  fitOne($("proof-club"), "--fitclub", avail);
  fitOne($("proof-month"), "--fitm", avail);
  fitOne($("proof-season"), "--fitseason", avail);
}
function fitOne(el, v, avail){
  if(!el || el.hidden) return;
  el.style.setProperty(v, "1");
  var w = el.scrollWidth;
  if(w > avail) el.style.setProperty(v, (avail / w * 0.98).toFixed(3));
}

function drawStrip(){
  var strip = $("proof-strip");
  if(months.length < 2){ strip.hidden = true; return; }
  strip.hidden = false;
  if(!strip.childNodes.length){
    months.forEach(function(mn){
      var b = document.createElement("button");
      b.type = "button"; b.className = "awb-monthtile"; b.textContent = mn.slice(0,3).toUpperCase(); b.title = mn;
      b.addEventListener("click", function(){ previewMonth = mn; render(); });
      strip.appendChild(b);
    });
  }
  Array.prototype.forEach.call(strip.children, function(b, i){
    b.setAttribute("aria-pressed", String(months[i] === previewMonth));
  });
}

function spec(){
  var parts = [];
  if(P.a || P.b) parts.push("<b>Award</b> " + [P.a, P.c, P.b].filter(Boolean).join(" "));
  if(P.club) parts.push("<b>Club</b> " + P.club);
  if(months.length) parts.push("<b>Months</b> " + months.join(", "));
  else if(P.season) parts.push("<b>Season</b> " + P.season);
  if(P.season && months.length) parts.push("<b>Season</b> " + P.season);
  parts.push("<b>Colours</b> " + (P.text || "") + " / " + (P.accent || ""));
  parts.push("<b>Layout</b> " + (P.layout || "classic"));
  if(P.sponsor === "1") parts.push("<b>Sponsor logo</b> yes");
  $("proof-spec").innerHTML = parts.join(" &middot; ");
}

// owner loads the crest downloaded from the order
$("proof-crestfile").addEventListener("change", function(){
  var f = this.files && this.files[0]; if(!f) return;
  if(crestUrl) URL.revokeObjectURL(crestUrl);
  crestUrl = URL.createObjectURL(f);
  render();
});

render();
if(document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
window.addEventListener("resize", fit);
})();
